export const getEventDedicatedPath = ({
  hasUser,
  event: { type, id },
  topicId,
  isWhitelabelGroup,
}) => {
  if (type === 'network_events_event') {
    if (topicId && !isWhitelabelGroup) {
      return Routes.topic_event_path(topicId, id);
    }

    if (hasUser) {
      return Routes.network_events_event_path(id);
    }

    return Routes.event_path(id);
  }

  return Routes.event_preview_path(id);
};

export const getEventDedicatedUrl = ({
  currentUrl,
  currentUser,
  event,
  topicId,
  isWhitelabelGroup,
}) =>
  `${currentUrl.origin}${getEventDedicatedPath({
    hasUser: !!currentUser,
    event,
    topicId,
    isWhitelabelGroup,
  })}`;
